import AirdropModalContent from "../components/airdropModalContent";
import { useBottomSheet } from "../context/BottomSheetContext";
import { useNavigate } from "react-router-dom";

export const useAirdropModal = () => {
  const { openSheet,closeSheet } = useBottomSheet();
  const navigate = useNavigate();

const openAirdropModal = (airdrop) => {
    openSheet({content:<AirdropModalContent navigate={navigate} airdrop={airdrop} closeModal={closeSheet} />,title:"Airdrop"})
 }
const closeAirdropModal = () => {
    closeSheet();
}   
  return { openAirdropModal ,closeAirdropModal};
}